class InternationalCalling {
	constructor(props) {
		console.log('InternationalCalling::constructor(%o)', props);

		let _that = this;
		_that.sell_countries = [];
		_that.page_ajax = {
			international_calling: {}
		};
		_that.page_timers = {
			international_calling: {}
		};
		_that.callbacks = {};
		_that = Object.assign(this, props);
		_that.international_dialing_nr = '011';
		_that.el = {
			destination_input: document.getElementById('destination_input'),
			call_destination_input: document.getElementById('call_destination_input'),
			calling_phone_number: document.getElementById('calling_phone_number'),
			how_to_call: document.getElementById('how_to_call_holder'),
			how_to_call_country: document.getElementById('how_to_call_country'),
			dialing_prefixes: document.getElementById('dialing_prefixes'),
			number_to_dial: document.getElementById('number_to_dial')
		};


		if (_that.el.destination_input) {
			const destination_country = _that.el.destination_input.value;
			if (destination_country) {
				_that.render_how_to_call_internationally(destination_country);
			}
		}

		if (_that.el.call_destination_input) {
			const form = _that.el.call_destination_input.closest('form');
			form.addEventListener('submit', (e) => {
				e.preventDefault();
			});

			let _suggested_countries = _that.sell_countries;
			let _product = 'mobile_credit';
			let fred = new autoComplete({
				minChars: 0,
				selector: _that.el.call_destination_input,
				menuClass: `countries-autocomplete-${_product}`,
				cache: 0,
				source(term, suggest) {
					if (term !== '') {
						let _matches = [];
						_suggested_countries.forEach((destination) => {
							if (destination.toLowerCase().indexOf(term.toLowerCase()) !== -1) {
								_matches.push(destination);
							}
						});

						suggest(_matches);
					}
				},
				async onSelect(e, destination) {
					fred.hideSC();
					_that.render_how_to_call_internationally(destination);
					if (_that.el.calling_phone_number) {
						setTimeout(() => {
							_that.el.calling_phone_number.focus();
						}, 100);
					}
				},
			});

			const search_calling = document.getElementById('search_calling');
			_that.el.call_destination_input.addEventListener('focusin', function (event) {
				search_calling.classList.add('active');
			});
			_that.el.call_destination_input.addEventListener('focusout', function (event) {
				search_calling.classList.remove('active');
			});
		}

		if (_that.el.calling_phone_number) {
			const phone = _that.el.calling_phone_number;
			phone.addEventListener('keyup', (event) => {
				if (event.isComposing || event.keyCode === 229) {
					return;
				}
				this.render_number_to_dial();
			});

			const phone_icon = document.getElementById('icon-phone');
			phone.addEventListener('focusin', function (event) {
				phone_icon.classList.add('active');
				_that.el.calling_phone_number.classList.add('active');
			});
			phone.addEventListener('focusout', function (event) {
				phone_icon.classList.remove('active');
				_that.el.calling_phone_number.classList.remove('active');
			});
		}

		if (_that.el.dialing_prefixes) {
			_that.el.dialing_prefixes.addEventListener('change', (event) => {
				this.render_number_to_dial();
			});
		}
	}

	async render_how_to_call_internationally(destination) {
		try {
			const form_data = new FormData();
			form_data.append('destination', destination);
			const res = fetcher(url('/process_international_call_info'), {
				method: 'post',
				body: form_data
			});
			const response = await res.ready;

			this.render_calling_country(response.short, response.country_name);
			this.render_dialing_prefixes(response.dialing_prefixes);
			this.render_how_to_call_country(response.translated);
			this.render_number_to_dial();
		} catch (e) {
			console.error(e);
			show_page_message('An error has occurred. Please refresh the page', 'status_error');
		}
	}

	render_number_to_dial() {
		const phone = this.el.calling_phone_number;
		const number_to_dial = this.el.number_to_dial;
		const dialing_prefixes_count = this.el.dialing_prefixes.dataset.prefixCount;
		let prefix_number = '+';
		let country_phone_nr = '';

		if (dialing_prefixes_count === '1') {
			// one prefix
			prefix_number = `${this.international_dialing_nr} ${this.el.dialing_prefixes.dataset.prefixPhoneNr}`;
		} else {
			// multiple prefixes
			const selected_attr = this.el.dialing_prefixes.options[this.el.dialing_prefixes.selectedIndex];
			country_phone_nr = selected_attr.value;
			country_phone_nr = country_phone_nr === '' ? this.international_dialing_nr : `${this.international_dialing_nr} ${country_phone_nr}`;
			prefix_number = country_phone_nr;
		}

		phone.value = phone.value.replace(/[^0-9]/g, '');
		const phone_validated = this.validate_phone_number(phone.value);

		if (phone_validated[0] && country_phone_nr !== this.international_dialing_nr) {
			this.el.how_to_call.style.display = 'block';
			const prefixed_phone = `${prefix_number} ${phone_validated[1]}`;
			number_to_dial.innerHTML = `${prefix_number} ${this.format_space_phone(phone_validated[1])}`;
			number_to_dial.href = `tel:${prefixed_phone.replace(/\s/g, '')}`;
		} else {
			this.el.how_to_call.style.display = 'none';
			number_to_dial.innerHTML = '';
		}
	}

	render_how_to_call_country(message) {
		this.el.how_to_call_country.innerHTML = message;
	}

	render_calling_country(country_short, country_name) {
		const input_country = this.el.call_destination_input.parentNode.querySelector('.input_country');
		input_country.classList.forEach((className) => {
			if (className.includes('flag32-')) {
				input_country.classList.remove(className);
			}
		});
		input_country.classList.add(`flag32-${country_short.toLowerCase()}`);
		this.el.call_destination_input.setAttribute('value', country_name);
	}

	render_dialing_prefixes(dialing_prefixes) {
		this.el.dialing_prefixes.dataset.prefixCount = dialing_prefixes.length;
		this.el.dialing_prefixes.dataset.prefixPhoneNr = dialing_prefixes.length ? dialing_prefixes : '+';
		this.el.dialing_prefixes.innerHTML = '';
		if (!dialing_prefixes || dialing_prefixes.length === 1) {
			this.el.dialing_prefixes.classList.add('hidden');
			return;
		}
		this.el.dialing_prefixes.classList.remove('hidden');
		const default_option = document.createElement('option');
		default_option.setAttribute('value', '');
		default_option.innerHTML = this.el.dialing_prefixes.dataset.optionChoosePrefix;
		this.el.dialing_prefixes.appendChild(default_option);
		dialing_prefixes.forEach(dialing_prefix => {
			let option = document.createElement('option');
			option.setAttribute('value', dialing_prefix);
			option.innerHTML = dialing_prefix;
			this.el.dialing_prefixes.appendChild(option);
		});
	}

	validate_phone_number(phone) {
		let valid = false;

		phone = phone.replace(/[^0-9]/g, '');
		phone = phone.replace(/^(011|0+)/, '');
		if (phone.length >= 7 && phone.length <= 15) {
			valid = true;
		}

		return [valid, phone];
	}

	format_space_phone(phone) {
		if (phone === '') {
			return '';
		}

		return phone.substr(0, 3) + ' ' + phone.substr(3, 3) + ' ' + phone.substr(6, 4) + ' ' + phone.substr(10, 4);
	}
}
